import { render } from "./UserImg.vue?vue&type=template&id=d811129e&scoped=true"
import script from "./UserImg.vue?vue&type=script&lang=js"
export * from "./UserImg.vue?vue&type=script&lang=js"

import "./UserImg.vue?vue&type=style&index=0&id=d811129e&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d811129e"]])

export default __exports__